import { useEffect } from "react";

const useTitle = (title?: string) => {
  useEffect(() => {
    document.title = title || "SPU Tools";
  }, [title]);
};

export default useTitle;
